import * as React from "react";
import styled from "@emotion/styled";
import {Button} from "@web2/button";
import {MarkerIcon} from "@web2/icons";

import {FlexColumn} from "../../../../app/atoms/Flex";
import {SectionBoxTitle} from "../SectionBoxTitle";

import map from "../../../../styles/assets/images/map_placeholder.png";

interface IOwnProps {
    title?: string;
}

export const Location = (props: IOwnProps) => {
    return (
        <>
            {props.title && <SectionBoxTitle title={props.title} toggler={false} />}

            <MapWrapper>
                <ButtonContainer>
                    <MarkerIcon height={40} width={40} />
                    <Button variant="primary">Zobacz na mapie</Button>
                </ButtonContainer>
            </MapWrapper>
        </>
    );
};

/*
Styles
 */

const MapWrapper = styled("div")`
    height: 126px;
    width: 100%;
    background-image: url("${map}");
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    display: flex;
    justify-content: center;
`;

const ButtonContainer = styled(FlexColumn)`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 20px;

    .svg-icon {
        margin-bottom: 15px;
    }

    .btn {
        width: 180px;
        font-weight: 500;
        font-size: 16px;
    }
`;
